import { Button, Collapse } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNotes, useSelect } from "../../../hooks";
import Empty from "../Empty";
import SearchBar from "./SearchBar";
import NoteInfo from "./NoteInfo";
import { useTranslation } from "react-i18next";
import emptyImage from "assets/svg/emptyImg.svg";
import EmptyComponent from "components/EmptyComponent";

export default function NotesTab() {
  const { notes, addNote } = useNotes();
  const { selectedElement, setSelectedElement } = useSelect();
  const { t } = useTranslation();

  return (
    <>
      <div className="flex gap-2">
        <SearchBar
          setActiveKey={(activeKey) =>
            setSelectedElement((prev) => ({
              ...prev,
              id: parseInt(activeKey),
            }))
          }
        />
        <div>
          <Button icon={<PlusOutlined />} block onClick={() => addNote()}>
            {/* {t("add_note")} */}
            添加注释
          </Button>
        </div>
      </div>
      {notes.length <= 0 ? (
        <EmptyComponent image={emptyImage} description="使用注释记录额外信息" />
      ) : (
        <Collapse
          activeKey={selectedElement.open ? `${selectedElement.id}` : ""}
          onChange={(activeKey) => {
            setSelectedElement((prev) => ({
              ...prev,
              id: parseInt(activeKey),
              open: true,
            }));
          }}
          accordion
          items={notes.map((n, i) => ({
            key: `${i}`,
            children: <NoteInfo data={n} nid={i} />,
          }))}
        />
      )}
    </>
  );
}
